<template>
  <div>
    <div id="postulateForm">
      <div id="content-form">
        <v-container fluid class="pt-0">
          <v-row>
            <v-col cols="12" sm="4" md="3" lg="2" class="nav-left pa-0 d-none d-sm-block">
              <SideMenu/>
            </v-col>
            <v-col cols="12" sm="8" md="9" lg="10" class="nav-right px-3 py-0 pl-sm-14">
              <v-parallax height="auto" src="@/assets/images/back-page.webp">
              <div class="stepper my-5">
                <v-container class="ma-auto pa-0">
                  <v-row>
                    <v-col cols="6">
                      <p class="pa-6">PASO 1: ACTUALIZAR PERFIL</p>
                    </v-col>
                    <v-col cols="6">
                      <p class="pa-6 active">PASO 2: RESPONDER PREGUNTAS Y POSTULAR</p>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
                <div class="webform">
                  <v-form ref="form">
                    <v-row class="pa-0">
                      <v-col cols="12" class="pa-0">
                        <v-card ref="form" color="transparent" class="form-card">
                          <div class="text-left">
                            <v-container class="px-0">
                              <v-row class="justify-md-start justify-center aling-start">
                                <div class="blue lighten-5 col-12 pa-6">
                                  <v-col cols="12" md="12" class="py-2 px-5" >
                                    <h3>Preguntas de la organización a la que estas postulando</h3>
                                    <p class="py-5">Completa las respuestas pensando en el cargo al que postulas</p>
                                  </v-col>
                                  <div v-if="offer">
                                    <v-form ref="form" v-model="form">
                                      <v-col cols="10" md="7" class="py-2 px-5" v-for="(question, index) in filteredQuestions" :key="index">
                                        <h4 v-if="question.label && question.label !== ''">{{ question.label }}</h4>
                                        <p v-if="index === 0 && question.id === 0 && !question.removed" class="tooltip-txt">
                                          Pon atención al tipo de moneda que aparece (USD o CLP), luego pon el valor solo con números, sin puntos ni comas.
                                        </p>
                                        <v-text-field
                                          class="mt-10"
                                          ref="answers"
                                          v-model="salary"
                                          :rules="[rules.required]"
                                          placeholder="Indica sueldo Liquido"
                                          v-if="index === 0 && question.id === 0 && !question.removed"
                                          :prefix="`${offer.salary.currency} $`"
                                          :disabled="already"
                                          type="number"
                                        />
                                        <v-textarea
                                          ref="answers"
                                          v-model="answers[index]"
                                          :rules="[rules.required, rules.minLength(1), rules.maxLength(500)]"
                                          counter="500"
                                          cols="10"
                                          md="7"
                                          placeholder="Escribe de manera simple. Se preciso en tus respuestas"
                                        /> 
                                      </v-col>
                                    </v-form>
                                  </div>
                                </div>
                              </v-row>
                            </v-container>
                          </div>
                          <div v-if="errors.length" class="error-form px-10">
                            <p>Favor corregir los siguientes errores:</p>
                            <ul>
                              <li v-for="error in errors" v-bind:key="error">
                                {{ error }}
                              </li>
                            </ul>
                          </div>
                          <v-card-actions class="text-center px-10" cols="8" md="7">
                            <v-row class="d-flex justify-start pt-15 mt-10 ">
                              <v-col cols="10" sm="5" md="4" lg="3" v-if="already">
                                <v-btn
                                  class="d-block btn-form"
                                  color="info"
                                  button
                                  large
                                  @click="goHome"
                                >
                                  INICIO
                                </v-btn>
                              </v-col>
                              <v-col cols="10" sm="5" md="4" lg="3" v-else>
                                <v-btn
                                  class="d-block btn-form"
                                  :disabled="!form || loading"
                                  :loading="loading"
                                  color="info"
                                  button
                                  large
                                  @click="postulateOffer"
                                >
                                  ENVIAR POSTULACIÓN
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <div class="text-center">
                  <v-dialog v-model="already" persistent max-width="500">
                    <v-card class="register-dialog pa-5 pa-sm-10" >
                      <div class="close-dialog">
                        <v-btn color="blue" class="float-right" icon @click="closeToHome()"><v-icon>mdi-close</v-icon></v-btn>
                      </div>
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12" align="center" class="pa-0">
                            <h3 class="text-center">Ya tienes una postulación hecha para este aviso.</h3>
                          </v-col>
                          <v-col cols="12" sm="10" md="10">
                            <p class="text-center">Recuerda que puedes seguir las etapas del proceso en “Mis postulaciones” de tu perfil.</p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-dialog>
                </div>
              </v-parallax>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu";
import { meta } from "../libs/mixins";

export default {
    props: ["slug", "offer", "posts"],

    validations: {
        answers: {},
    },

    components: {
        SideMenu
    },

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Postulación",
        });
    }, 

    data() {
        return {
            errors: [],
            min: 0,
            max: 0,
            answers: [],
            finished: false,
            modal: false,
            loading: false,
            already: false,
            salary: null,
            salaryNoFormat: 0,
            rules: {
                required: v => !!v || "Este campo es obligatorio",
                minLength: len => v => (v || "").length >= len || `Se requieren al menos ${len} caracteres en este campo.`,
                maxLength: len => v => (v || "").length <= len || `No se puede agregar mas de ${len} caracteres en este campo.`,
            },
            form: false,
        };
    },

    created() {
        let post = this.posts.find(item => item.offer.slug === this.slug);
        if (post) {
            // TODO: que hacer si se postuló?
            this.already = true;
            this.salary = post.salary;
            this.answers = post.answers;
        }
    },

    watch: {
        salary(value) {
            this.salary = parseInt(value.toString().replace(/([.,])/g, ""));
        }
    },

    computed: {
        filteredQuestions() {
            console.log(this.offer.questions);
            return this.offer.questions.filter(q => q.removed !== true);
            // let questionsFiltered = this.offer.questions.filter(question => !question.removed);
            // return questionsFiltered.slice(1);
        }
    },

    methods: {
        avatarPath(org) {
            //// TODO cambiar imagen, cuando se haya sobrecargado la actual ////
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (org && org.media && org.media.logo && org.media.logo != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + org.media.logo;
            }
            if (org.alias && org.alias !== "") {
                path = require("@/assets/images/avatar-default-icon.webp");
            }
            return path;
        },
        saveAnswers(e) {
            // TODO: que hacer con este boton
            const request = {
                offer: this.offer,
                postulation: {
                    userId: this.offer.id,
                    answers: this.answers,
                    salary: parseInt(this.salary.toString().replace(/([.,])/g, "")),
                },
            };
        },
        postulateOffer(e) {
            this.loading = true;
            let salar = 0;
            try {
                salar = parseInt(this.salary.toString().replace(/([.,])/g, ""));
            } catch {
                salar = 0;
            }
            this.$store.dispatch("users/postulate", {
                offerId: this.offer.id,
                organizationId: this.offer.organization.id,
                postulation: {
                    answers: this.answers,
                    salary: salar,
                }
            }).then(result => {

                this.$store.dispatch("cookies/activity", {
                    path: this.$route.path,
                    activity: "taskComplete"
                });

                this.$router.push({ name: "PostulateSuccess", params: { title: this.offer.title, coNames: this.offer.organization.name } });
                this.loading = false;
            }).catch(err => {
                this.$store.dispatch("cookies/activity", {
                    path: this.$route.path,
                    activity: "taskError",
                    args: JSON.stringify(err)
                });

                this.loading = false;
                this.errors = err;
            });
        },
        goHome() {
            this.$router.push({ name: "CandidateDashboard" });
        },
        closeToHome() {
            this.finished = false;
            this.already = false;

            this.$router.push({ name: "CandidateDashboard" });
        }
    }
};
</script>

<style scoped>
#postulateForm {
  padding-top: 15px;
}
.logo-job{
    border-radius:50px;
    margin:0 auto;
}
</style>
